/* eslint-disable react/require-default-props */
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MAIN_PATH } from 'src/constants/routePaths';
import { Icon, Layout } from '@vwfs-bronson/bronson-react';
import globalConstants from '../../../../constants/globalConstants';

interface LinkItemProps {
  label: string;
  to: string | undefined;
  active?: boolean;
  badge?: number | string;
  brand: string;
  'data-testid'?: string;
  onClick?: () => void;
}

const LinkItem: React.FC<LinkItemProps> = ({
  label,
  to,
  onClick = () => {},
  active = false,
  badge = '',
  brand,
  'data-testid': dataTestId,
}: LinkItemProps) => {
  const badgeIsNumber = !!+badge;

  const location = useLocation();
  // first element should be empty always since pathname always starts with '/'
  const [, ENTRY_PATH] = location.pathname.split('/');

  // pointing directly to absolute path is required because, app could be used by Portal, Zoid or Dashboard
  const ABSOLUTE_PATH = (() => {
    // if path is the same it means it is running as standalone, required to pass e2e tests
    if (ENTRY_PATH === MAIN_PATH) return `/${MAIN_PATH}/${to}` as const;

    return `/${ENTRY_PATH}/${MAIN_PATH}/${to}` as const;
  })();
  return (
    <Layout flush className='asidebar-nav__item__label'>
      {active && brand.toLowerCase() === globalConstants.AUDI_BRAND && <Icon name='semantic-forward' size='small' />}
      <Link
        onClick={!to ? onClick : undefined}
        to={!to ? undefined : ABSOLUTE_PATH}
        className='c-link'
        data-testid={dataTestId}
      >
        {active ? (
          <strong>
            <span className='c-link__body sidebar_link_body'>{label}</span>
          </strong>
        ) : (
          <span className='c-link__body sidebar_link_body'>{label}</span>
        )}
      </Link>

      {badgeIsNumber ? (
        <span className='c-badge__wrapper  u-ml-xsmall'>
          <span className='c-badge  c-badge--notification'>{badge}</span>
        </span>
      ) : (
        ''
      )}
    </Layout>
  );
};

export default LinkItem;
